function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.5,98.228c-3.038,0-5.5-2.463-5.5-5.5V92.62c0-3.038,2.462-5.5,5.5-5.5s5.5,2.462,5.5,5.5v0.107 C11,95.765,8.538,98.228,5.5,98.228"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.5,75.572c-1.933,0-3.5-1.567-3.5-3.5V3.5C2,1.567,3.567,0,5.5,0C7.434,0,9,1.567,9,3.5v68.572 C9,74.005,7.434,75.572,5.5,75.572"
});

var SvgAttenzione = function SvgAttenzione(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 99,
    viewBox: "-0.406 -0.489 12 99",
    enableBackground: "new -0.406 -0.489 12 99",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttenzione, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attenzione.e580a799.svg";
export { ForwardRef as ReactComponent };